const screenRecorder = async () => {
  // eslint-disable-next-line
  const stream = await navigator.mediaDevices.getDisplayMedia({
    video: {
      mediaSource: 'screen',
    },
  });

  const audioStream = await navigator.mediaDevices.getUserMedia({ audio: true }).catch((e) => { throw e; });
  const audioTrack = audioStream.getAudioTracks()[0];
  stream.addTrack(audioTrack);

  const mediaRecorder = new MediaRecorder(stream);
  return mediaRecorder;
};

export default screenRecorder;
